import { extend, useThree } from '@react-three/fiber'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

export default function CameraOrbit() {
  const rootDOM = document.querySelector('#root')
  extend({ OrbitControls })

  const { camera, gl } = useThree()
  // console.log('useThree', scene)
  return <orbitControls args={[camera, gl.domElement]} />
}
